import { Navigate, Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const MfaEnforcementBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const e = user?.mfa_enforcement;
  if (!e?.required) return null;
  if (e.blocked && location.pathname !== "/profile") return <Navigate to="/profile" replace />;
  const when = new Date(e.deadline).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  return (
    <div className={`mb-4 flex flex-wrap items-center gap-2 rounded-md border px-4 py-2.5 text-sm ${e.blocked ? "border-red-200 bg-red-50 text-red-800" : "border-amber-200 bg-amber-50 text-amber-900"}`} data-testid="mfa-enforcement-banner">
      <ShieldAlert size={16} className="shrink-0" />
      <span>
        {e.blocked
          ? "Two-factor authentication is now required for admin accounts. Set it up below to continue using the system."
          : `Admin accounts must turn on two-factor authentication by ${when}.`}
      </span>
      {location.pathname !== "/profile" && <Link to="/profile" className="font-semibold underline underline-offset-2" data-testid="mfa-banner-setup-link">Set it up now</Link>}
    </div>
  );
};
